<script setup lang="ts">
/**
 * UI-kit component
 * Category: Loaders
 * Name: LoaderOverlay
 * FIGMA: https://www.figma.com/design/n8yjfgcFUgYPq4BLYjeYcJ/Design-System--Client?node-id=22864-46
 */
import type { LoaderOverlayProps } from '../types/interfaces'

import { LoaderBlock } from '../../loader-block'

defineOptions({
  name: 'LoaderOverlay',
})

withDefaults(defineProps<LoaderOverlayProps>(), {
  size: 'lg',
  glass: true,
})
</script>

<template>
  <div :class="['loader-overlay', { 'loader-overlay--glass': glass }]">
    <LoaderBlock :size="size" />
  </div>
</template>

<style lang="scss" scoped src="../styles/_loader-overlay.scss" />
